import { createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../../utils/axiosInterceptor';

export const initStateUpdateUserAutoEmployers = {
  updateUserAutoEmployers: { data: null, loading: false, error: null },
};

export const updateUserAutoEmployers = createAsyncThunk('user/updateUserAutoEmployers', async ({ userId, auto_employers }, { rejectWithValue, fulfillWithValue }) => {
  return await axiosInstance
    .put(
      `${process.env.REACT_APP_SERVER_API}/users/${userId}/auto-employers`,
      { auto_employers },
      {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      },
    )
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response?.data || res.response);
    });
});

export const reducerUpdateUserAutoEmployers = {
  [updateUserAutoEmployers.pending]: (state) => {
    state.updateUserAutoEmployers.data = null;
    state.updateUserAutoEmployers.loading = true;
    state.updateUserAutoEmployers.error = null;
  },
  [updateUserAutoEmployers.fulfilled]: (state, action) => {
    state.updateUserAutoEmployers.loading = false;
    state.updateUserAutoEmployers.data = action.payload ?? true;
    state.updateUserAutoEmployers.error = null;
  },
  [updateUserAutoEmployers.rejected]: (state, action) => {
    state.updateUserAutoEmployers.data = null;
    state.updateUserAutoEmployers.loading = false;
    state.updateUserAutoEmployers.error = action.payload;
  },
};
